import pyFormSelect from 'pylon-vue/src/components/form-select/form-select';

const sFormSelect = {
    name: 'sFormSelect',
    extends: pyFormSelect
}

export default sFormSelect